export default "__VITE_ASSET__CVY4YkHt__"